angular
    .module('app')
    .component('winbackCampaignsList', {
        templateUrl: '/templates/pages/winback-campaigns/winback-campaigns-list/winback-campaigns-list.html',
        controller: 'WinbackCampaignsListController',
        controllerAs: 'vm',
    });